export const AUTH_GATEWAY_VISUAL_TOKENS = Object.freeze({
  panel: {
    width: 440,
    minHeight: 410,
    paddingX: { xs: 3.125, sm: 4.75 },
    paddingY: { xs: 7.5, sm: 7.75 },
    radius: { xs: 4, sm: 5 },
    background: "linear-gradient(160deg, rgba(28,30,37,.72), rgba(10,12,18,.62))",
    border: "1px solid rgba(255,255,255,.15)",
    shadow: "0 28px 75px rgba(0,0,0,.34), inset 0 1px 0 rgba(255,255,255,.08)",
    blur: "blur(24px) saturate(118%)",
  },
  logo: { width: 148, height: 58, marginBottom: 2.5 },
  heading: { xs: 28, sm: 30 },
  body: { xs: 15, sm: 16 },
  button: {
    minHeight: 50,
    radius: 3.25,
    background: "linear-gradient(180deg, rgba(255,255,255,.12), rgba(255,255,255,.055))",
    hover: "linear-gradient(180deg, rgba(255,255,255,.18), rgba(255,255,255,.085))",
    border: "1px solid rgba(255,255,255,.17)",
  },
});
